<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>Hitler’s Wolfsschanze</h1>
<p class="subtitle">The Wolf’s Lair Headquarters on the Eastern Front – An Illustrated Guide</p>
<p class="author">John Grehan</p>
<div class="img_containerr"><img alt="images" src="images/pub.jpg"/></div>
<p class="author1">AN IMPRINT OF PEN &amp; SWORD BOOKS LTD</p>
<p class="author1">YORKSHIRE – PHILADELPHIA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?4ab9404b